import React from 'react';

import './Avatar.scss';

const Avatar = ({ className, filename, alt, width, height }) => {
  return (
    <div className={`avatar ${className}`}>
      <img
        src={`${process.env.REACT_APP_ASSET_URL}/img/admin/${filename}`}
        alt={alt}
        style={{ width: width, height: height }}
      />
    </div>
  );
};

export default Avatar;
